<template>
  <a-card hoverable
          class="cardStyle"
          @mouseenter="mouseFunc.customizeEnter"
          @mouseleave="mouseFunc.customizeLeave">
    <template #cover>
      <div class="cardStyle-image">
        <div ref="hiddenContainer"
             class="hidden"></div>
        <!-- <img :src="toUrl(theme.image)" /> -->
        <div v-if="hiddenContainer"
             class="viewer">
          <ImageCustomizeEditor v-if="prodcutDesginShareThemeData && prodcutDesginShareThemeData.customableImage && prodcutDesginShareThemeData.customableImage.custom_areas"
                                :id="prodcutDesginShareThemeData.customableImage.id + ''"
                                mode="view"
                                :container="hiddenContainer"
                                :template-basic-parameters="templateBasicParameters(prodcutDesginShareThemeData.customableImage)"
                                :custom-area="assignDssProductCustomizedData(prodcutDesginShareThemeData)"
                                :customized-image="renderDssProductImageCustomUrl(prodcutDesginShareThemeData)" />
        </div>
      </div>
    </template>
    <a-card-meta :title="theme.title"
                 class="cardBox">
      <template #description>
        <div class="card-details">
          <div class="cardStyle-cardDesc-priceDesc"
               :style="{
                 flex: baseDiscount.clothing.value != 100 ? 'none' : '0.9'
               }">
            <div v-if="baseDiscount.clothing.value != 100"
                 class="discountSellPrice">¥{{ calcPackagePrice(false)
                 }}<span class="start-price"> {{ $t('DesignShare.DssCategoriesCardPage.rise') }}</span></div>
            <span v-if="baseDiscount.clothing.value != 100"
                  class="discountPrice">¥{{ calcPackagePrice(true) }}</span>
            <div v-if="baseDiscount.clothing.name != $t('DesignShare.DssCategoriesCardPage.originalPrice')"
                 class="discountText">
              <span>{{ baseDiscount.clothing.name }}</span>
            </div>
            <div v-if="baseDiscount.clothing.value === 100"
                 class="discountSellPrice">¥{{ calcPackagePrice(false)
                 }}<span class="start-price"> 起</span></div>
          </div>
          <div class="card-details-desginer">
            {{ $t('DesignShare.DssCategoriesCardPage.designer') }}:{{ hideMobileNumber(theme.user.username) }}
          </div>
        </div>
      </template>
    </a-card-meta>
    <div v-show="operationType"
         class="dss-buy-opation">
      <a-button class="dss-buy-product"
                @click="addCart(theme.customSpus)">
        {{ $t('DesignShare.DssCategoriesCardPage.buyClothing') }}
      </a-button>
      <a-button class="dss-buy-product"
                @click="buyTheme">
        {{ $t('DesignShare.DssCategoriesCardPage.buyDesign') }}
      </a-button>
    </div>
  </a-card>
  <a-modal v-model:visible="themeVisible"
           width="900px"
           :body-style="{ height: '500px', overflow: 'auto' }"
           :title="selectedTheme.dsstheme?.title"
           :destroy-on-close="true"
           @cancel="handleCancel">
    <div class="desgin-share-modal-desginer">{{ $t('DesignShare.DssCategoriesCardPage.designer') }}：{{
      hideMobileNumber(selectedTheme.dsstheme?.user.username!) }}</div>
    <a-tag v-if="!selectedTheme.dsstheme?.shareable"
           color="orange">{{ $t('DesignShare.DssCategoriesCardPage.hintSecondaryDesign') }}</a-tag>
    <a-tag v-if="selectedTheme.dsstheme?.free"
           color="orange">{{ $t('DesignShare.DssCategoriesCardPage.hintFree') }}</a-tag>
    <div class="desgin-share-modal-desc">
      <span>{{ $t('DesignShare.DssCategoriesCardPage.hintIllustrate') }}</span>
      <span>{{ $t('DesignShare.DssCategoriesCardPage.hintCost') }}</span>
      <span>{{ $t('DesignShare.DssCategoriesCardPage.hintRightOfUse') }}</span>
    </div>
    <div class="desgin-share-modal-images">
      <div v-for="(item, index) in selectedTheme.dsstheme?.shareImages"
           :key="index"
           :class="['desgin-share-modal-content', findSelectedImage(item.id!) ? 'desgin-share-modal-border' : '']">
        <div class="desgin-share-modal-image"
             @click="addImage(item)"><img :src="toUrl(toWatermark(item.image))"
               alt=""></div>
        <div class="desgin-share-modal-text"><span class="desgin-share-modal-price">¥ {{ item.ref_price }}</span></div>
      </div>
    </div>
    <template #footer>
      <div class="desgin-share-modal-footer">
        <div class="desgin-share-modal-buy">
          <a-radio v-model:checked="selectedTheme.buyWholeSet"
                   :disabled="selectedTheme.buyWholeSet || selectedTheme.dsstheme?.free"
                   @change="onBuyThemeImages">{{ $t('DesignShare.DssCategoriesCardPage.BuyTheFullSet') }}</a-radio>
          <div>{{ $t('DesignShare.DssCategoriesCardPage.DesignPackagePrice') }}:<span class="desgin-share-modal-price">¥
              {{ selectedTheme.dsstheme?.price }}</span></div>
        </div>
        <div class="desgin-share-modal-footer-buttons">
          <div class="desgin-share-modal-footer-button">
            <a-button key="back"
                      @click="handleCancel">{{ $t('DesignShare.DssCategoriesCardPage.cancel') }}</a-button>
            <a-popconfirm :title="$t('DesignShare.DssCategoriesCardPage.jumpDesgin')"
                          :ok-text="$t('DesignShare.DssCategoriesCardPage.jump')"
                          :cancel-text="selectedTheme.buyWholeSet ? '' : $t('DesignShare.DssCategoriesCardPage.addOnly')"
                          :disabled="(!selectedTheme.buyWholeSet && !selectedTheme.selectedCustomizedImages.length)"
                          @confirm="handleOk(true)"
                          @cancel="handleOk()">
              <a-button key="submit"
                        type="primary"
                        :disabled="(!selectedTheme.buyWholeSet && !selectedTheme.selectedCustomizedImages.length)"
                        :loading="confirmLoading">{{ $t('DesignShare.DssCategoriesCardPage.toUse') }}</a-button>
            </a-popconfirm>
          </div>
        </div>
      </div>
    </template>
  </a-modal>
  <a-modal v-model:visible="payVisible"
           :title="'确认购买' + selectedTheme.dsstheme?.title + '?'"
           :destroy-on-close="true"
           @ok="confirmPay"
           @cancel="cancelPay">
    <div class="desgin-share-modal-desginer">{{ $t('DesignShare.DssCategoriesCardPage.designer') }}：{{
      hideMobileNumber(selectedTheme.dsstheme?.user.username!) }}</div>
    <div class="desgin-share-modal-desc">
      <span>{{ $t('DesignShare.DssCategoriesCardPage.hintBuyTheFullSet') }}</span>
      <span>{{ $t('DesignShare.DssCategoriesCardPage.hintBuyTheFullSetcost') }}</span>
      <span>{{ $t('DesignShare.DssCategoriesCardPage.hintRefund') }}</span>
    </div>
    <a-radio-group v-model:value="payType"
                   name="radioGroup">
      <a-radio :value="0">{{ $t('DesignShare.DssCategoriesCardPage.alipay') }}</a-radio>
      <a-radio :value="1">{{ $t('DesignShare.DssCategoriesCardPage.wxpay') }}</a-radio>
      <a-radio :value="3">{{ $t('DesignShare.DssCategoriesCardPage.walletPay') }}</a-radio>
    </a-radio-group>
  </a-modal>
  <a-modal v-model:visible="QRCodeVisible"
           :title="payType === 0 ? $t('DesignShare.DssCategoriesCardPage.aliScanCode') : $t('DesignShare.DssCategoriesCardPage.wxScanCode')"
           :z-index="1001"
           :mask-closable="false"
           :body-style="{ display: 'flex', justifyContent: 'center', flexFlow: 'column', alignItems: 'center' }"
           :ok-text="$t('DesignShare.DssCategoriesCardPage.paid')"
           @ok="onCancelOk"
           @cancel="QRCodeVisible = false">
    <div class="flex">
      <iframe v-if="payType === 0"
              :src="aliPayUrl"
              width="210"
              height="210"></iframe>
      <a-image v-else
               :width="200"
               :preview="false"
               :src="code_img" />
    </div>
    <div class="flex">
      {{ $t('DesignShare.DssCategoriesCardPage.QRPay') }}
    </div>
  </a-modal>
  <DssShoppingCartModal ref="shoppingCart" />
  <a-modal v-model:visible="loginVisible"
           :footer="null"
           :width="450">
    <iota-simple-signin :options="{ newWindowToResetPassword: true }"
                        @success="loginSuccess" />
  </a-modal>
</template>

<script setup lang="ts">
import {
  CUSTOMABLE_IMAGE_SERVICE,
  type AccountInfoOption,
  type AccountInfoService,
  type CustomableImageService
} from "&/main"
import type { Plugin } from "@/plugins"
import { toUrl, toWatermark, hideMobileNumber } from '@/utils'
import { ImageCustomizeEditor } from "@iota-cn/ui-components"
import { PLUGIN_ACCOUNT_INFO } from "@/plugins/builtin/BuiltinPluginSymbol"
import { templateBasicParameters, assignDssProductCustomizedData, renderDssProductImageCustomUrl } from "../utill"
import { container } from "tsyringe"
import { nextTick, onMounted, ref } from "vue"
import DssShoppingCartModal from "./components/DssShoppingCartModal.vue"
import { addDssOrder, dssAlipayQuery, dssWxpayQuery, addUmsDssOrderItem } from "../api"
import type { ProdcutDesginShareTheme, CustomSpu, Reference, BuyDssTheme, ShareImage, RawCustomizedImage } from "../configure"
import BigNumber from "bignumber.js"
import { message } from 'ant-design-vue'
import QRCode from 'qrcode'
import { useRouter } from "vue-router"
import { CORE_USER, type UserService } from "@/core"
import { useI18n } from "vue-i18n"

const { t } = useI18n()
BigNumber.config({ ROUNDING_MODE: 1 })
const discountStore =
  container.resolve<Plugin<AccountInfoOption, AccountInfoService>>(
    PLUGIN_ACCOUNT_INFO
  )
const { calculateDiscount } = discountStore.service
const { baseDiscount } = discountStore.options as any
const hiddenContainer = ref()
// declare Function
const props = defineProps<{
  theme: ProdcutDesginShareTheme
  isHome: boolean
}>()
const selectedTheme = ref<BuyDssTheme>({
  dsstheme: undefined,
  selectedCustomizedImages: [],
  buyWholeSet: false
})
const router = useRouter()
const loginVisible = ref<boolean>(false)
const confirmLoading = ref<boolean>(false)
const loginSuccess = () => {
  loginVisible.value = !loginVisible.value
}
const number = ref<string>('')
const payType = ref<number | null>(null)
const operationType = ref<boolean>(false)
const themeVisible = ref<boolean>(false)
const payVisible = ref<boolean>(false)
const aliPayUrl = ref<string>('')
const code_img = ref('')
const QRCodeVisible = ref<boolean>(false)
const prodcutDesginShareThemeData = ref<RawCustomizedImage>()

const customableImageService = ref<CustomableImageService>()
onMounted(() => {
  customableImageService.value = container.resolve<CustomableImageService>(
    CUSTOMABLE_IMAGE_SERVICE
  )
  initBackGroundImg()
})

const initBackGroundImg = () => {
  const currentData = props.theme
  if (currentData.customSpus[0].customizedImages[0].customableImage.altImages) {
    currentData.customSpus[0].customizedImages[0].customableImage.image = currentData.customSpus[0].customizedImages[0].customableImage.altImages[0].alt_image
  }
  prodcutDesginShareThemeData.value = currentData.customSpus[0].customizedImages[0]
}

const onBuyThemeImages = () => {
  payVisible.value = true
}

const onCancelOk = async () => {
  if (payType.value === 0) {
    const data = { number: `${number.value}` }
    const res: any = await dssAlipayQuery(data)
    if (res.msg == 'success') {
      message.success(t('home.HeaderMenu.paymentSuccessful'))
      payVisible.value = false
      QRCodeVisible.value = false
      payType.value = null
      selectedTheme.value.buyWholeSet = true
    } else {
      message.error(t('home.HeaderMenu.hintUnpaid'))
    }
  } else if (payType.value === 1) {
    const data = { number: `${number.value}-PC` }
    const res: any = await dssWxpayQuery(data)
    if (res.result.result_code == 'SUCCESS' && res.result.trade_state == 'SUCCESS') {
      message.success(res.result.trade_state_desc)
      payVisible.value = false
      QRCodeVisible.value = false
      payType.value = null
      selectedTheme.value.buyWholeSet = true
    } else {
      message.error(res.result.trade_state_desc)
    }
  }
}

const handleOk = async (toDesgin: boolean = false) => {
  if (selectedTheme.value.buyWholeSet) {
    if (toDesgin) {
      router.push({ path: "/products/custom_spus_design" })
    }
  } else {
    const data = {
      dss_theme_id: selectedTheme.value.dsstheme?.id,
      dss_customized_image_id: selectedTheme.value.selectedCustomizedImages.map((r: ShareImage) => r.id),
    }
    await addUmsDssOrderItem(data).then((res: any) => {
      message.success(res.message)
      if (toDesgin) {
        router.push({ path: "/products/custom_spus_design" })
      }
    })
  }
  // if (!selectedTheme.value.selectedCustomizedImages.length) {
  //   themeVisible.value = false
  //   selectedTheme.value.dsstheme = undefined
  //   selectedTheme.value.selectedCustomizedImages = []
  //   selectedTheme.value.buyWholeSet = false
  //   return
  // }
  // themeVisible.value = false
  // selectedTheme.value.dsstheme = undefined
  // selectedTheme.value.selectedCustomizedImages = []
  // selectedTheme.value.buyWholeSet = false
}

const confirmPay = async () => {
  if (!payType.value && payType.value != 0) {
    selectedTheme.value.buyWholeSet = false
    payVisible.value = false
    return
  }
  if (selectedTheme.value.dsstheme) {
    const addDssOrderData = {
      themeId: selectedTheme.value.dsstheme.id,
      payType: payType.value,
      price: selectedTheme.value.dsstheme.price,
      title: selectedTheme.value.dsstheme.title
    }
    await addDssOrder(addDssOrderData).then(async (res: any) => {
      if (payType.value === 1) {
        number.value = res.number
        QRCodeVisible.value = true
        code_img.value = await QRCode.toDataURL(res.url)
      } else if (payType.value === 0) {
        aliPayUrl.value = res.url
        number.value = res.number
        QRCodeVisible.value = true
      } else {
        if (res.message == 'SUCCESS') {
          message.success(t('home.HeaderMenu.paymentSuccessful'))
        }
        payVisible.value = false
        payType.value = null
      }
    }).catch((err: any) => {
      if (err.message == 'Insufficient balance')
        message.error(t('home.HeaderMenu.insufficientBalance'))
      else
        message.error(err.message)
    })
  }
}

const addImage = (customizedImage: ShareImage) => {
  const savingImage = selectedTheme.value.selectedCustomizedImages.findIndex((r: ShareImage) => r.id === customizedImage.id)
  if (savingImage === -1) {
    selectedTheme.value.selectedCustomizedImages.push(customizedImage)
  } else {
    selectedTheme.value.selectedCustomizedImages.splice(savingImage, 1)
  }
}

const calcPackagePrice = (isOriginal: boolean) => {
  let designFees = '0'
  props.theme.customSpus[0].references.forEach((r: Reference) => {
    designFees = new BigNumber(designFees).plus(r.customizedImage.ref_price).toFixed(2)
  })
  if (isOriginal) {
    return new BigNumber(props.theme.customSpus[0].price).plus(designFees).toFixed(2)
  } else {
    if (calculateDiscount("clothing", props.theme.customSpus[0].price))
      return new BigNumber(calculateDiscount("clothing", props.theme.customSpus[0].price)).plus(designFees).toFixed(2)
    else
      return new BigNumber(props.theme.customSpus[0].price).plus(designFees).toFixed(2)
  }
}

const findSelectedImage = (id: number) => {
  return selectedTheme.value.selectedCustomizedImages.find((r: ShareImage) => r.id === id)
}

const handleCancel = () => {
  themeVisible.value = false
  selectedTheme.value.dsstheme = undefined
  selectedTheme.value.selectedCustomizedImages = []
  selectedTheme.value.buyWholeSet = false
}

const cancelPay = () => {
  selectedTheme.value.buyWholeSet = false
  payVisible.value = false
}

const customizeViewerType = ref<boolean>(false)
// declare Method
const mouseFunc = {
  customizeEnter: () => {
    customizeViewerType.value = true
    operationType.value = true
  },
  customizeLeave: () => {
    customizeViewerType.value = false
    operationType.value = false
  },
}

const shoppingCart = ref<any>()
const isLogin = () => {
  const userService = container.resolve<UserService>(CORE_USER)
  const user = userService.getUser()
  if (Object.entries(user.value).length < 1) {
    loginVisible.value = true
  }
}
// 加入购物车
const addCart = async (value: CustomSpu[]) => {
  isLogin()
  if (loginVisible.value)
    return
  shoppingCart.value.show()
  nextTick(() => {
    shoppingCart.value.setProduct(value)
  })
}
const buyTheme = () => {
  isLogin()
  if (loginVisible.value)
    return
  selectedTheme.value.dsstheme = props.theme
  selectedTheme.value.buyWholeSet = !!(props.theme.dssOrders.length && props.theme.dssOrders[0].status >= 1)
  themeVisible.value = !themeVisible.value
}
</script>

<style lang="less" scoped>
.cardStyle {
  margin: 20px;
  height: 450px;
  width: 350px;
  user-select: none;
  position: relative;

  .dss-buy-opation {
    position: absolute;
    top: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-flow: column;
    width: 100%;
    height: 100%;
    background-color: #99999910;

    .dss-buy-product {
      margin-top: 20px;
      width: 80%;
      height: 30px;
      background: rgba(255, 255, 255, 0.85);
    }
  }

  &:nth-child(4n+1) {
    margin-left: 20px !important;
  }

  &:nth-child(n+2) {
    margin-left: 40px;
  }


  :deep(.ant-card-cover) {
    margin: 0;
    position: relative;
  }

  :deep(.ant-card-body) {
    display: flex;
    // padding: 20px 0 0 16px;
    padding: 0;

    .cardBox {
      width: 100%;

      .ant-card-meta-detail {
        padding: 10px;
      }

      .ant-card-meta-title {
        padding: 0;
        font-family: Microsoft YaHei;
        font-weight: bold;
        font-size: 16px;
        color: #111111;
      }

      .card-details {
        display: flex;
        flex-flow: column;
        justify-content: space-between;

        .card-details-desginer {
          font-family: Microsoft YaHei;
          font-weight: 400;
          font-size: 14px;
          color: #999999;
        }
      }
    }
  }

  .cardStyle-image {
    width: 350px;
    height: 350px;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    margin: auto;
    background-color: #F6F6F6 100%;

    .hidden {
      width: 350px;
      height: 350px;
      position: absolute;
      visibility: hidden;
      display: block;
    }

    .viewer {
      width: 350px;
      height: 350px;
      display: flex;
      justify-content: center;
      align-items: center;

      @-moz-document url-prefix() {
        :deep(.fabric-div) {
          width: 350px !important;
          height: 350px !important;
        }

        :deep(.canvas-container) {
          width: 350px !important;
          height: 350px !important;
        }

        :deep(.lower-canvas) {
          width: 350px !important;
          height: 350px !important;
        }

        :deep(.upper-canvas) {
          width: 350px !important;
          height: 350px !important;
        }
      }
    }
  }

  &-cardColor {
    display: flex;
    height: 55px;
    transition: 0.3s linear;
    position: absolute;
    background: url(../assets/cardColorBg.png) no-repeat;
    background-size: cover;
    justify-content: center;
    align-items: flex-end;
    bottom: 0;
    scrollbar-width: none;

    &-colorBox {
      width: 280px;
      overflow: hidden;
      overflow-x: auto;
      white-space: nowrap;
      transition: 0.3s linear;
      scrollbar-width: none;

      &-box {
        transition: 0.3s linear;
        display: inline-block;
        width: 22px;
        height: 22px;
        background-size: cover;
        border-radius: 2px;
        margin-left: 4px;
        margin-right: 1px;
        border: 1px solid #d7d7d7;

        &-image {
          width: 100%;
          height: 100%;
          background-size: cover !important;
        }
      }

      .active {
        border: 2px solid #373737;
      }
    }

    &-colorBox::-webkit-scrollbar {
      display: none;
    }

    &-iconClass {
      width: 12px;
      height: 12px;
      margin-bottom: 10px;
    }

    &-leftIcon {
      background: url("../../home/assets/imgs/ic-left_lined.png") no-repeat;
      background-size: contain;
      margin-right: 10px;
      margin-left: 10px;
    }

    &-rightIcon {
      background: url("../../home/assets/imgs/ic-right_lined.png") no-repeat;
      background-size: contain;
      float: right;
      margin-right: 10px;
      margin-left: 10px;
    }
  }

  &-cardColor::-webkit-scrollbar {
    display: none;
  }

  &-cardContent {
    height: fit-content;
    width: 95%;
    padding-left: 14px;

    .descMaterial {
      -webkit-line-clamp: 2;
      display: flex;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      word-break: break-all;
    }

    div {
      margin-top: 5px;
      font-size: 14px;
      color: #999999;
      line-height: 20px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: flex;

      .leftTitle {
        flex: 0.3;

        .icon {
          background-size: contain;
          width: 16px;
          height: 16px;
          display: inline-block;
          margin-top: 2px;
        }

        .title {
          margin-left: 5px;
          margin-right: 5px;
          font-size: 14px;
          color: #111111;
          line-height: 20px;
        }
      }

      .deliverTitle {
        flex: 0.5 !important;
      }

      .rightBox {
        flex: 1;
      }
    }

    .descTitle {
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      overflow: hidden;
      /*! autoprefixer: off */
      -webkit-box-orient: vertical;
      height: 40px;
    }
  }

  &-cardOperate {
    display: flex;
    width: 100%;
    margin-top: 60px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding-left: 0px;

    .ant-btn {
      overflow: hidden;
      text-overflow: ellipsis;
      width: 100%;
      height: 32px;
      border-radius: 4px;
      margin-top: 8px;
      font-family: "Microsoft YaHei";
      font-size: 14px;
      line-height: 22px;
      height: 40px;
      width: 90%;
      margin-top: 0;
      margin-right: 0;
    }

    .ant-btn:first-child {
      background-color: #111111;
      color: #ffffff;
    }

    .ant-btn:not(:first-child) {
      color: #999999;
      margin-top: 10px;
    }
  }

  &-cardDesc {
    display: inline-flex;
    align-items: center;
    padding-left: 16px;
    width: 100%;

    &-descTitle {
      height: 50px;
    }

    &-priceDesc {
      font-size: 14px;
      font-family: "Microsoft YaHei Bold";
      color: #de4a09;
      line-height: 22px;
      display: inline-flex;
      align-items: baseline;
      flex: 0.9;

      .discountSellPrice {
        float: left;
        font-size: 20px;
        color: red;
      }

      .discountPrice {
        color: #999999;
        text-decoration: line-through;
        float: left;
      }

      .discountText {
        display: inline-flex;
        background: #fae4da;
        justify-content: center;
        align-items: center;
        margin: 5px;
        padding: 0 1px 0 1px;

        span {
          color: #de4a09 !important;
          font-size: 14px;
          font-family: "Microsoft YaHei";
        }
      }

      span:not(:first-child) {
        margin-left: 8px;
      }
    }

    &-sellDesc {
      font-size: 14px;
      color: #999999;
      font-family: "Microsoft YaHei";
      line-height: 22px;
      padding-left: 35px;

      .shoppingIcon {
        display: inline-flex;
        justify-content: center;
        align-items: center;
        width: 24px;
        height: 24px;
        font-size: 16px;
        background: #f6f6f6;
      }
    }
  }

  &-cart {
    float: right;
    font-size: 18px;
    line-height: 22px;
    margin-right: 20px;
  }

  :deep(.ant-card-meta-title) {
    font-family: "Microsoft YaHei Bold";
    white-space: normal;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding: 20px 0 0 16px;
  }
}

.images {
  height: 100%;
  overflow: hidden;
  overflow-y: auto;
}
</style>

<style lang="less">
.fb-card-detail {
  top: 5vh;
  height: 90vh;
  bottom: 20px;
  padding-bottom: 0;

  .ant-modal-body {
    height: calc(100% - 56px);
    overflow-x: hidden;
    overflow-y: auto;
  }

  .ant-modal-content {
    height: 100%;
  }
}

.start-price {
  font-size: 14px;
  color: #999999;
  display: inline-block;
  font-family: "Microsoft YaHei";
  margin-left: 5px;
  transform-origin: 0 1;
}
</style>
